import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-142a7ff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "max-w-body-width mx-auto w-body-width"
}
const _hoisted_2 = {
  key: 0,
  class: "text-xl my-xl text-black font-bold text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-xl my-xl text-black font-bold text-center"
}
const _hoisted_4 = { class: "flex flex-col hd:flex-row justify-between" }
const _hoisted_5 = {
  key: 0,
  class: "hd:flex-half hd:mr-standard",
  id: "interactive"
}
const _hoisted_6 = { class: "mb-lg" }
const _hoisted_7 = { class: "flex mb-md" }
const _hoisted_8 = ["id", "value", "checked", "onInput"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "my-auto" }
const _hoisted_11 = { class: "my-auto font-normal text-font" }
const _hoisted_12 = { class: "pl-lg hidden tablet:block" }
const _hoisted_13 = { class: "text-sm text-accent tablet:hidden" }
const _hoisted_14 = { class: "mb-lg" }
const _hoisted_15 = {
  key: 0,
  class: "-mx-lg p-lg bg-primary-disabled mb-lg"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Zu Ihrem gewählten Produkt bieten wir Ihnen folgendes Leihgerät an: ", -1))
const _hoisted_17 = { class: "flex flex-col tablet:flex-row justify-between my-lg text-lg text-black" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm tablet:text-base" }, "0.0 CHF / Monat", -1))
const _hoisted_20 = { class: "text-left tablet:text-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "loaned-router"
}, "Ich will das Leihgerät beziehen!", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-lg" }, " Alternativ bieten wir Ihnen auch folgende Geräte zum Kauf an: ", -1))
const _hoisted_23 = { class: "flex mb-md" }
const _hoisted_24 = ["id", "value", "checked", "onInput"]
const _hoisted_25 = ["for"]
const _hoisted_26 = { class: "my-auto" }
const _hoisted_27 = { class: "my-auto font-normal text-font" }
const _hoisted_28 = { class: "pl-lg hidden tablet:block" }
const _hoisted_29 = { class: "text-sm text-accent tablet:hidden" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "Aufschaltung", -1))
const _hoisted_31 = { class: "flex justify-between mb-lg" }
const _hoisted_32 = { class: "flex-half items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-xl text-black font-bold",
  for: "speed-standard"
}, "Sofort", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-font-disabled" }, "* bis zu 10 Arbeitstage", -1))
const _hoisted_35 = { class: "flex-half items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-xl text-black font-bold",
  for: "speed-express"
}, "Express", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-font-disabled" }, "* bis zu 2 Arbeitstage (645.00 CHF)", -1))
const _hoisted_38 = { class: "flex-half items-center mb-lg" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-xl text-black font-bold",
  for: "custom-date"
}, "Wunschdatum", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "Laufzeit", -1))
const _hoisted_41 = { class: "flex justify-between" }
const _hoisted_42 = { class: "flex-half items-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-xl text-black font-bold",
  for: "contract-12"
}, "12 Monate", -1))
const _hoisted_44 = { class: "flex-half items-center" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-xl text-black font-bold",
  for: "contract-36"
}, "36 Monate", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "Kundenangaben", -1))
const _hoisted_47 = { class: "flex flex-col tablet:flex-row justify-between items-center mb-md" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ml-standard" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Anrede"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-md text-primary" })
], -1))
const _hoisted_49 = { class: "flex flex-half" }
const _hoisted_50 = { class: "mr-lg" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "mr"
}, "Herr", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "mrs"
}, "Frau", -1))
const _hoisted_53 = { class: "mb-lg" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "Zahlungsart", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-black font-bold" }, " Ich will, dass die Abrechnung ", -1))
const _hoisted_56 = { class: "flex px-lg tablet:px-xl items-center my-lg flex-wrap" }
const _hoisted_57 = { class: "mr-2xl" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "monthly"
}, "monatlich", -1))
const _hoisted_59 = { class: "mr-2xl" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "halfyearly"
}, "halbjährlich", -1))
const _hoisted_61 = { class: "mr-2xl" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "quarterly"
}, "per Quartal", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-black font-bold" }, "erfolgt.", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "Aufschaltadresse", -1))
const _hoisted_65 = { class: "flex flex-col" }
const _hoisted_66 = { class: "flex flex-col mx-auto" }
const _hoisted_67 = { class: "text-lg text-black font-bold" }
const _hoisted_68 = { class: "mb-standard text-lg text-black font-bold" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "Lieferadresse", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "delivery-address-identical"
}, "identisch mit Kundenangaben", -1))
const _hoisted_71 = { class: "mb-lg" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-lg text-black font-bold",
  for: "delivery-address-other"
}, "andere Adresse", -1))
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "flex items-center mb-standard" }
const _hoisted_75 = { class: "flex items-center mb-standard" }
const _hoisted_76 = {
  key: 1,
  class: ""
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "OTO ID (Optional)", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-lg" }, " An Ihrem Standord ist eine Glasfaserverbindung vorhanden. Um den Anschluss schnellstmöglich freizuschalten, teilen Sie uns bitte die OTO ID, die Sie auf ihrer Anschlussbuchse finden können, mit. Sollte dies gerade nicht möglich sein, können Sie das Feld unausgefüllt lassen, und uns die OTO ID später mitteilen. ", -1))
const _hoisted_79 = {
  key: 2,
  class: ""
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-lg" }, "NSN Nummer (Optional)", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-lg" }, " An Ihrem Standord ist eine DSL-Verbindung vorhanden. Um den Anschluss schnellstmöglich freizuschalten, teilen Sie uns bitte die NSN Nummer mit. Sollten Sie diese nicht kennen, können Sie uns auch den Vor- und Nachnamen des Vormieters mitteilen. Sollte dies gerade nicht möglich sein, können Sie das Feld unausgefüllt lassen, und uns diese Daten später übermitteln. ", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Bemerkungen (fixe IP,spezielle Wünsche)", -1))
const _hoisted_83 = { class: "mb-lg flex flex-col flex-center justify-center" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode(" Ich habe die "),
  /*#__PURE__*/_createElementVNode("a", { href: "/support/agb" }, "AGBs"),
  /*#__PURE__*/_createTextVNode(" gelesen und akzeptiere diese ")
], -1))
const _hoisted_85 = { class: "mt-lg flex flex-col tablet:flex-row justify-between" }
const _hoisted_86 = {
  key: 1,
  class: "flex-third",
  id: "summary"
}
const _hoisted_87 = { class: "sticky summary-container" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 px-standard" }, " Zusammenfassung ", -1))
const _hoisted_89 = {
  key: 0,
  class: "m-auto"
}
const _hoisted_90 = { key: 1 }
const _hoisted_91 = { class: "flex items-baseline" }
const _hoisted_92 = { class: "flex-grow my-auto" }
const _hoisted_93 = { class: "flex-grow" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "flex-quarter bg-accent text-center text-primary-contrast p-standard rounded text-sm" }
const _hoisted_96 = {
  key: 0,
  class: "flex items-baseline"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "flex-grow my-auto" }, "Aufschaltung")
], -1))
const _hoisted_98 = { class: "flex-quarter bg-accent text-center text-primary-contrast p-standard rounded text-sm" }
const _hoisted_99 = {
  key: 1,
  class: "flex items-baseline"
}
const _hoisted_100 = { class: "flex-grow" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "flex-grow my-auto" }, "Leihgerät", -1))
const _hoisted_102 = { class: "flex-quarter bg-accent text-center text-primary-contrast p-standard rounded text-sm" }
const _hoisted_103 = {
  key: 0,
  class: "flex items-baseline"
}
const _hoisted_104 = { class: "flex-grow my-auto" }
const _hoisted_105 = { class: "flex-grow" }
const _hoisted_106 = { class: "text-font" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { class: "flex-quarter bg-accent text-center text-primary-contrast p-standard rounded text-sm" }
const _hoisted_109 = { class: "flex justify-center m-lg" }
const _hoisted_110 = {
  key: 2,
  class: "mt-auto border-t-2 pt-2 border-font-disabled"
}
const _hoisted_111 = { class: "flex justify-between" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-grow" }, "Einmalig:", -1))
const _hoisted_113 = { class: "flex-quarter" }
const _hoisted_114 = { class: "flex justify-between" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-grow" }, "Monatlich:", -1))
const _hoisted_116 = { class: "flex-quarter" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-0 px-standard" }, " Adresse ", -1))
const _hoisted_118 = { class: "flex flex-col" }
const _hoisted_119 = { class: "mx-auto" }
const _hoisted_120 = { class: "" }
const _hoisted_121 = { class: "mb-lg" }
const _hoisted_122 = {
  key: 0,
  class: "mb-lg text-center text-accent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_input_control = _resolveComponent("input-control")!
  const _component_ButtonControl = _resolveComponent("ButtonControl")!
  const _component_LocationCheck = _resolveComponent("LocationCheck")!

  return ($setup.availableMainProducts.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($setup.currentStep <= 2)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Schritt " + _toDisplayString($setup.currentStep) + "/2 ", 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, " Konfigurieren ")),
        _createElementVNode("div", _hoisted_4, [
          (!$setup.showSummary)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                ($setup.currentStep === 5)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.form.selectedMainProduct)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.subCategories, (category, i) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `subcat-${i}`
                            }, [
                              (category !== 'router' && category !== 'bridge')
                                ? (_openBlock(), _createBlock(_component_Card, {
                                    key: 0,
                                    class: "p-lg mb-md last:mb-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", _hoisted_6, "Fixe " + _toDisplayString($setup.ProductCategories[category]) + " (optional)", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categorizedProducts[category], (product, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "mb-lg",
                                          key: `main-${i}`
                                        }, [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("input", {
                                              class: "my-auto",
                                              id: product.name,
                                              type: "checkbox",
                                              value: product,
                                              checked: 
                        $setup.form.selected[category] &&
                          $setup.form.selected[category] === product
                      ,
                                              onInput: ($event: any) => (
                        $setup.form.selected[category] &&
                        $setup.form.selected[category] === product
                          ? ($setup.form.selected[category] = null)
                          : ($setup.form.selected[category] = product)
                      )
                                            }, null, 40, _hoisted_8),
                                            _createElementVNode("label", {
                                              class: "flex flex-col tablet:flex-row w-full justify-between text-xl text-black my-auto font-bold ml-md",
                                              for: product.name
                                            }, [
                                              _createElementVNode("span", _hoisted_10, _toDisplayString(product.name), 1),
                                              _createElementVNode("span", _hoisted_11, _toDisplayString(`${product.price} ${product.currency}${
                          $setup.paymentIntervalStrings[product.payment_interval]
                        }`), 1)
                                            ], 8, _hoisted_9)
                                          ]),
                                          _createElementVNode("ul", _hoisted_12, [
                                            _createElementVNode("li", null, _toDisplayString(product.feature_descriptions.description_1), 1)
                                          ]),
                                          _createElementVNode("p", _hoisted_13, _toDisplayString(product.feature_descriptions.description_1), 1)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (category === 'router')
                                ? (_openBlock(), _createBlock(_component_Card, {
                                    key: 1,
                                    class: "p-lg mb-md last:mb-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h2", _hoisted_14, _toDisplayString($setup.ProductCategories[category]), 1),
                                      ($setup.loanableRouter)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _hoisted_16,
                                            _createElementVNode("div", _hoisted_17, [
                                              _createElementVNode("span", _hoisted_18, _toDisplayString($setup.loanableRouter.name), 1),
                                              _hoisted_19
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "mr-md",
                                                type: "checkbox",
                                                id: "loaned-router",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.loanedDevice) = $event))
                                              }, null, 512), [
                                                [_vModelCheckbox, $setup.form.loanedDevice]
                                              ]),
                                              _hoisted_21
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _hoisted_22,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableRouters, (product, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "mb-lg",
                                          key: `main-${i}`
                                        }, [
                                          _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("input", {
                                              class: "my-auto",
                                              id: product.name,
                                              type: "checkbox",
                                              value: product,
                                              checked: 
                      $setup.form.selected[category] &&
                        $setup.form.selected[category] === product
                    ,
                                              onInput: ($event: any) => (
                      $setup.form.selected[category] &&
                      $setup.form.selected[category] === product
                        ? ($setup.form.selected[category] = null)
                        : ($setup.form.selected[category] = product)
                    )
                                            }, null, 40, _hoisted_24),
                                            _createElementVNode("label", {
                                              class: "flex flex-col tablet:flex-row w-full justify-between text-xl text-black my-auto font-bold ml-md",
                                              for: product.name
                                            }, [
                                              _createElementVNode("span", _hoisted_26, _toDisplayString(product.name), 1),
                                              _createElementVNode("span", _hoisted_27, _toDisplayString(`${product.price} ${product.currency}${
                        $setup.paymentIntervalStrings[product.payment_interval]
                      }`), 1)
                                            ], 8, _hoisted_25)
                                          ]),
                                          _createElementVNode("ul", _hoisted_28, [
                                            _createElementVNode("li", null, _toDisplayString(product.feature_descriptions.description_1), 1)
                                          ]),
                                          _createElementVNode("p", _hoisted_29, _toDisplayString(product.feature_descriptions.description_1), 1)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                ($setup.currentStep === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_Card, { class: "p-lg mb-md" }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                id: "speed-standard",
                                class: "mr-md",
                                type: "radio",
                                value: "standard",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.installation) = $event))
                              }, null, 512), [
                                [_vModelRadio, $setup.form.installation]
                              ]),
                              _hoisted_33,
                              _hoisted_34
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _withDirectives(_createElementVNode("input", {
                                id: "speed-express",
                                class: "mr-md",
                                type: "radio",
                                value: "express",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.installation) = $event))
                              }, null, 512), [
                                [_vModelRadio, $setup.form.installation]
                              ]),
                              _hoisted_36,
                              _hoisted_37
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              id: "custom-date",
                              type: "radio",
                              value: "custom",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.installation) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.form.installation]
                            ]),
                            _hoisted_39,
                            ($setup.form.installation === 'custom')
                              ? (_openBlock(), _createBlock(_component_datepicker, {
                                  key: 0,
                                  class: "z-10",
                                  modelValue: $setup.form.customInstallationDate,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.customInstallationDate) = $event)),
                                  lowerLimit: $setup.minInstallationDate
                                }, null, 8, ["modelValue", "lowerLimit"]))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _withDirectives(_createElementVNode("input", {
                                id: "contract-12",
                                class: "mr-md",
                                type: "radio",
                                value: "12",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.contractTime) = $event))
                              }, null, 512), [
                                [_vModelRadio, $setup.form.contractTime]
                              ]),
                              _hoisted_43
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                id: "contract-36",
                                class: "mr-md",
                                type: "radio",
                                value: "36",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.contractTime) = $event))
                              }, null, 512), [
                                [_vModelRadio, $setup.form.contractTime]
                              ]),
                              _hoisted_45
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Card, { class: "p-lg mb-md" }, {
                        default: _withCtx(() => [
                          _hoisted_46,
                          ($setup.shopMode === 'business')
                            ? (_openBlock(), _createBlock(_component_input_control, {
                                key: 0,
                                class: "mb-lg",
                                name: "Firma",
                                modelValue: $setup.v$.company.$model,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.v$.company.$model) = $event))
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "mr-md",
                                  type: "radio",
                                  value: "Herr",
                                  id: "mr",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.v$.salutation.$model) = $event))
                                }, null, 512), [
                                  [_vModelRadio, $setup.v$.salutation.$model]
                                ]),
                                _hoisted_51
                              ]),
                              _createElementVNode("div", null, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "mr-md",
                                  type: "radio",
                                  value: "Frau",
                                  id: "mrs",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.v$.salutation.$model) = $event))
                                }, null, 512), [
                                  [_vModelRadio, $setup.v$.salutation.$model]
                                ]),
                                _hoisted_52
                              ])
                            ])
                          ]),
                          _createVNode(_component_input_control, {
                            class: "mb-lg",
                            name: "Vorname *",
                            modelValue: $setup.v$.name.$model,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.v$.name.$model) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_input_control, {
                            class: "mb-lg",
                            name: "Nachname *",
                            modelValue: $setup.v$.surname.$model,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.v$.surname.$model) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_input_control, {
                            class: "mb-lg",
                            name: "Strasse / Hausnummer *",
                            "model-value": `${$setup.street} ${$setup.houseNr}`,
                            readonly: ""
                          }, null, 8, ["model-value"]),
                          _createVNode(_component_input_control, {
                            class: "mb-lg",
                            name: "Strasse / Hausnummer *",
                            "model-value": `${$setup.zip} ${$setup.city}`,
                            readonly: ""
                          }, null, 8, ["model-value"]),
                          _createVNode(_component_input_control, {
                            class: "mb-lg",
                            name: "Telefon *",
                            modelValue: $setup.v$.phone.$model,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.v$.phone.$model) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_input_control, {
                            class: "mb-lg",
                            name: "Email *",
                            modelValue: $setup.v$.email.$model,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.v$.email.$model) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                ($setup.currentStep === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createVNode(_component_Card, { class: "p-lg mb-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _hoisted_55,
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "mr-md",
                                  type: "radio",
                                  id: "monthly",
                                  value: "monthly",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.form.receiptInterval) = $event))
                                }, null, 512), [
                                  [_vModelRadio, $setup.form.receiptInterval]
                                ]),
                                _hoisted_58
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "mr-md",
                                  type: "radio",
                                  id: "halfyearly",
                                  value: "halfyearly",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.form.receiptInterval) = $event))
                                }, null, 512), [
                                  [_vModelRadio, $setup.form.receiptInterval]
                                ]),
                                _hoisted_60
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "mr-md",
                                  type: "radio",
                                  id: "quarterly",
                                  value: "quarterly",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.form.receiptInterval) = $event))
                                }, null, 512), [
                                  [_vModelRadio, $setup.form.receiptInterval]
                                ]),
                                _hoisted_62
                              ])
                            ]),
                            _hoisted_63
                          ]),
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("p", _hoisted_67, _toDisplayString($setup.zip) + " " + _toDisplayString($setup.city), 1),
                              _createElementVNode("p", _hoisted_68, _toDisplayString($setup.street) + " " + _toDisplayString($setup.houseNr), 1)
                            ]),
                            _createVNode(_component_ButtonControl, {
                              class: "mx-auto mb-lg",
                              label: "ÄNDERN",
                              "button-style": "secondary",
                              width: "300px"
                            })
                          ]),
                          _hoisted_69,
                          _createElementVNode("p", null, [
                            _withDirectives(_createElementVNode("input", {
                              class: "mr-md",
                              type: "radio",
                              id: "delivery-address-identical",
                              value: "identical",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.form.deliveryAddress) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.form.deliveryAddress]
                            ]),
                            _hoisted_70
                          ]),
                          _createElementVNode("p", _hoisted_71, [
                            _withDirectives(_createElementVNode("input", {
                              class: "mr-md",
                              type: "radio",
                              id: "delivery-address-other",
                              value: "other",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.form.deliveryAddress) = $event))
                            }, null, 512), [
                              [_vModelRadio, $setup.form.deliveryAddress]
                            ]),
                            _hoisted_72
                          ]),
                          ($setup.form.deliveryAddress === 'other')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                  _createVNode(_component_input_control, {
                                    class: "mb-lg mr-md",
                                    name: "Strasse",
                                    required: "",
                                    modelValue: $setup.v$.alternateStreet.$model,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.v$.alternateStreet.$model) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_input_control, {
                                    class: "mb-lg",
                                    name: "Hausnummer",
                                    required: "",
                                    modelValue: $setup.v$.alternateHouseNr.$model,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.v$.alternateHouseNr.$model) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_component_input_control, {
                                    class: "mb-lg mr-md",
                                    name: "PLZ",
                                    required: "",
                                    modelValue: $setup.v$.alternatePlz.$model,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.v$.alternatePlz.$model) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_input_control, {
                                    class: "mb-lg",
                                    name: "Ort",
                                    required: "",
                                    modelValue: $setup.v$.alternateTown.$model,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.v$.alternateTown.$model) = $event))
                                  }, null, 8, ["modelValue"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.connectionType === 'fiber')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                _hoisted_77,
                                _hoisted_78,
                                _createVNode(_component_input_control, {
                                  class: "mt-md",
                                  modelValue: $setup.form.otoId,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.form.otoId) = $event)),
                                  name: "OTO ID"
                                }, null, 8, ["modelValue"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _hoisted_80,
                                _hoisted_81,
                                _createVNode(_component_input_control, {
                                  class: "mt-md",
                                  modelValue: $setup.form.nsn,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.form.nsn) = $event)),
                                  name: "NSN Nummer"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_input_control, {
                                  class: "mt-md",
                                  modelValue: $setup.form.previousTenant,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.form.previousTenant) = $event)),
                                  name: "Name des Vormieters"
                                }, null, 8, ["modelValue"])
                              ])),
                          _hoisted_82,
                          _createVNode(_component_input_control, {
                            type: "textarea",
                            name: "Nachricht",
                            modelValue: $setup.form.message,
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.form.message) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Card, { class: "p-lg mb-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_83, [
                            _withDirectives(_createElementVNode("input", {
                              class: "mr-md mb-lg",
                              type: "checkbox",
                              id: "agb",
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.v$.agb.$model) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, $setup.v$.agb.$model]
                            ]),
                            _hoisted_84
                          ])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_85, [
                  _createVNode(_component_ButtonControl, {
                    class: "confirm order-2 tablet:order-none",
                    width: "300px",
                    label: "ZURÜCK",
                    "button-style": "secondary",
                    disabled: $setup.currentStep === 1 || $setup.currentStep === 5,
                    onClick: $setup.previousStep
                  }, null, 8, ["disabled", "onClick"]),
                  _createVNode(_component_ButtonControl, {
                    class: "order-1 mb-lg tablet:order-none tablet:mb-0 confirm",
                    width: "300px",
                    "button-style": "primary",
                    disabled: $setup.stepInvalid || $setup.loading,
                    label: 
              $setup.currentStep == 5
                ? 'SPEICHERN'
              : $setup.currentStep < 2
                ? 'WEITER'
                : $setup.isMobile
                ? 'ZUSAMMENFASSUNG'
                : 'BESTELLEN'
            ,
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (
              $setup.currentStep == 5
                ? $setup.goBack()
                : $setup.currentStep < 2
                ? $setup.nextStep()
                : $setup.isMobile
                ? ($setup.showSummary = true)
                : $setup.order()
            ))
                  }, null, 8, ["disabled", "label"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!$setup.isMobile || ($setup.isMobile && $setup.showSummary))
            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_component_Card, { class: "flex flex-col mb-md min-h-lg p-lg order-2 tablet:order-none" }, {
                    default: _withCtx(() => [
                      _hoisted_88,
                      (!$setup.form.selectedMainProduct)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_89, " Bitte wählen Sie ein Produkt. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("h3", _hoisted_93, _toDisplayString($setup.form.selectedMainProduct.name), 1),
                                (
                      $setup.form.selectedMainProduct.feature_descriptions
                        .description_1
                    )
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString($setup.form.selectedMainProduct.feature_descriptions
                        .description_1), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_95, _toDisplayString($setup.form.selectedMainProduct.price) + " " + _toDisplayString($setup.form.selectedMainProduct.currency) + " " + _toDisplayString($setup.paymentIntervalStrings[
                      $setup.form.selectedMainProduct.payment_interval
                    ]), 1)
                            ]),
                            ($setup.form.selectedMainProduct)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                  _hoisted_97,
                                  _createElementVNode("p", _hoisted_98, _toDisplayString($setup.installationCosts[$setup.form.installation]) + " " + _toDisplayString($setup.form.selectedMainProduct.currency) + " " + _toDisplayString($setup.paymentIntervalStrings[0]), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.form.loanedDevice)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                  _createElementVNode("div", _hoisted_100, [
                                    _hoisted_101,
                                    _createElementVNode("p", null, _toDisplayString($setup.loanableRouter.name), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_102, " 0.00 " + _toDisplayString($setup.form.selectedMainProduct.currency) + " " + _toDisplayString($setup.paymentIntervalStrings[0]), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.selected, (selectedProduct) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `summary-${selectedProduct}`
                              }, [
                                (
                    selectedProduct && Object.keys(selectedProduct).length > 0
                  )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                      _createElementVNode("div", _hoisted_104, [
                                        _createElementVNode("h3", _hoisted_105, _toDisplayString(selectedProduct.name), 1),
                                        _createElementVNode("div", _hoisted_106, [
                                          (
                          selectedProduct.feature_descriptions.description_1
                        )
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString(selectedProduct.feature_descriptions.description_1), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("p", _hoisted_108, _toDisplayString(selectedProduct.price) + " " + _toDisplayString(selectedProduct.currency) + " " + _toDisplayString($setup.paymentIntervalStrings[
                        $setup.form.selectedMainProduct.payment_interval
                      ]), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])),
                      _createElementVNode("div", _hoisted_109, [
                        _createVNode(_component_ButtonControl, {
                          class: "mx-auto",
                          label: "KONFIGURIEREN",
                          "button-style": "secondary",
                          width: "300px",
                          disabled: $setup.currentStep == 5,
                          onClick: $setup.configure
                        }, null, 8, ["disabled", "onClick"])
                      ]),
                      ($setup.form.selectedMainProduct)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _hoisted_112,
                              _createElementVNode("p", _hoisted_113, _toDisplayString($setup.selectedPrices.once.toFixed(2)) + "." + _toDisplayString($setup.form.selectedMainProduct.currency), 1)
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _hoisted_115,
                              _createElementVNode("p", _hoisted_116, _toDisplayString($setup.selectedPrices.monthly.toFixed(2)) + "." + _toDisplayString($setup.form.selectedMainProduct.currency), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Card, { class: "p-lg mb-md tablet:mb-0 order-1 tablet:order-none" }, {
                    default: _withCtx(() => [
                      _hoisted_117,
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("p", _hoisted_120, _toDisplayString($setup.zip) + " " + _toDisplayString($setup.city), 1),
                          _createElementVNode("p", _hoisted_121, _toDisplayString($setup.street) + " " + _toDisplayString($setup.houseNr), 1)
                        ]),
                        ($setup.connectionType === 'fiber' || $setup.connectionType === 'dsl')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_122, _toDisplayString(`An dieser Adresse ist ein ${
                    $setup.connectionType === "dsl" ? "DSL" : "Fiber"
                  } Anschluss verfügbar`), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ButtonControl, {
                          class: "mx-auto",
                          label: "ÄNDERN",
                          "button-style": "secondary",
                          width: "300px"
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  ($setup.showSummary)
                    ? (_openBlock(), _createBlock(_component_ButtonControl, {
                        key: 0,
                        class: "mx-auto mb-md order-3",
                        disabled: $setup.stepInvalid || $setup.loading,
                        label: "BESTELLEN",
                        "button-style": "primary",
                        width: "300px",
                        onClick: $setup.order
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  ($setup.showSummary)
                    ? (_openBlock(), _createBlock(_component_ButtonControl, {
                        key: 1,
                        class: "mx-auto order-4",
                        disabled: $setup.stepInvalid,
                        label: "ZURÜCK",
                        "button-style": "secondary",
                        width: "300px",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.showSummary = false))
                      }, null, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_LocationCheck, { key: 1 }))
}